import { Reducer, combineReducers } from 'redux'
import { UserInfoUIState, UserInfoActionTypes } from './types'
import { IUser } from '../interface'

// Type-safe initialState!
const initialState: UserInfoUIState = {
    loading: false,
    processing: false,
    processState : 0,  // 0: Initial, 1: Success, 2: Failed
    selected: undefined,
    errors: undefined,
    isConflict : false,
    totDoc : 0
}

const ui: Reducer<UserInfoUIState> = (state = initialState, action) => {
    switch (action.type) {
        // List
        case UserInfoActionTypes.LIST_REQUEST: {
            return { ...state, loading: true, isConflict : false, processState: 0, searchParams : action.payload }
        }
        case UserInfoActionTypes.LIST_SUCCESS: {
            return { ...state, loading: false, isConflict : false, processState: 1, totDoc: action.payload.totalDoc }
        }
        case UserInfoActionTypes.LIST_ERROR: {
            return { ...state, loading: false, isConflict : false, processState: 2, errors: action.payload.errors }
        }
        case UserInfoActionTypes.LIST_CLEAR: {
            return { ...state, loading: false, isConflict : false, processState: 0, totDoc : 0, searchParams : undefined, errors : undefined }
        }
        // Select
        case UserInfoActionTypes.SELECT: {
            return { ...state, loading: true, processState: 0, selected: action.payload };
        }
        case UserInfoActionTypes.SELECTED: {
            return { ...state, loading: false, processState: 0 };
        }
        case UserInfoActionTypes.CLEAR_SELECTED: {
            return { ...state, loading: false, processState: 0, selected: undefined };
        }
        default: {
            return state
        }
    }
}


const byId: Reducer<{}> = (state = {}, action) => {
    switch (action.type) {
        case UserInfoActionTypes.LIST_SUCCESS: {
            var _temp: any = {};
            if (action.payload.isSuccess){
                // console.log("User Info Reducer");
                // console.log(action.payload.doc);

                _temp['0'] =  action.payload.doc;
            }
            return { ...state, ..._temp };
            //return action.payload.doc;


            // if (action.payload.isSuccess && action.payload.totalDoc > 0){  
            //     if (action.payload.offset == 0){ 
            //         // Reset initial search
            //         action.payload.doc.forEach((item: IUser) => {
            //             _temp[item.id] = item;
            //         });
            //         return _temp;
            //     }
            //     else
            //     {
            //         // Combine if load more
            //         const currentStateList:any = {...state};
            //         action.payload.doc.forEach((item: IUser) => {
            //             if(currentStateList[item.id] === undefined)
            //             {
            //                 _temp[item.id] = item;
            //             }
            //         });
            //         return { ...state, ..._temp };
            //     }
            // }else{
            //     return _temp;
            // }
        }
        default: {
            return state
        }
    }
}

const allIds: Reducer<string[]> = (state = [], action) => {
    switch (action.type) {
        case UserInfoActionTypes.LIST_SUCCESS: {
            if (action.payload.totalDoc > 0){  
                if (action.payload.offset ==0){
                    var results:any =[];
                    results = action.payload.doc.map((item: IUser) => item.id);
                    return results;
                }else{
                    const results = [...state];
                    action.payload.doc.forEach((item: IUser) => {
                        if(results.some((s)=>s === item.id) === false)
                        {
                            results.push(item.id);
                        }
                    });
                    return results;
                }
            }else{
                var results:any =[];
                return results;
            }
        }
        default: {
            return state
        }
    }
}


// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
const UserInfosReducer = combineReducers({
    ui,
    byId,
    allIds,
    // byCategory,
    // Category
})
export default UserInfosReducer
